package com.essntl.features.area.ui.allareas

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.area.domain.repository.AreaRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AllAreasViewModel(
    private val areaRepository: AreaRepository,
    private val state: MutableStateFlow<AllAreasState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: AllAreasEvent) {
        when (event) {
            is AllAreasEvent.GetAllAreas -> getAllAreas()
            is AllAreasEvent.AddArea -> addArea(event)
            is AllAreasEvent.EditArea -> editArea(event)
            is AllAreasEvent.DeleteArea -> deleteArea(event)
        }
    }

    private fun getAllAreas() =
        getData(
            getData = { areaRepository.getAll() },
            getState = { state.value.getAllAreas },
            setState = { newState -> state.update { it.copy(getAllAreas = newState) } },
        )

    private fun addArea(event: AllAreasEvent.AddArea) =
        state.update {
            it.copy(
                getAllAreas = it.getAllAreas.copy(
                    data = it.getAllAreas.data.orEmpty() + event.a,
                ),
            )
        }

    private fun editArea(event: AllAreasEvent.EditArea) =
        state.update {
            it.copy(
                getAllAreas = it.getAllAreas.copy(
                    data = it.getAllAreas.data
                        .orEmpty()
                        .map { a ->
                            if (a.id == event.a.id) event.a else a
                        },
                ),
            )
        }

    private fun deleteArea(event: AllAreasEvent.DeleteArea) =
        state.update {
            it.copy(
                getAllAreas = it.getAllAreas.copy(
                    data = it.getAllAreas.data
                        .orEmpty()
                        .filter { a ->
                            a.id != event.a.id
                        },
                ),
            )
        }
}